<template>
  <div class="personal-info-content">
    <div class="title-header" ref="title_header">
      <div class="back-icon-box" >
        <i class="iconfont icon-fanhui1 go-back-icon" @click="goBack"></i>
      </div>
      <div class="settle-title">个人资料</div>
      <span @click="submitInfo">完成</span>
    </div>
    <div class="info-box">
      <div class="user-image-box">
        <img class="user-image" v-bind:src="imageUrl" alt="">
        <upload-image ref="uploadImage" :preview-image="false" style="display: inline-block" :max-size="1" @getImage="getImage">
          <span class="change-image-btn">更换头像</span>
        </upload-image>
      </div>
      <van-field v-model="userName" label="昵称" maxlength="10" input-align="right" />
      <div @click="openSexSelect">
        <van-field v-model="sex" placeholder="请选择性别" label="性别" readonly input-align="right" />
      </div>
    </div>
    <van-action-sheet v-model="display.sexSelect" :actions="actions" @select="onSelectSex" />
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import uploadImage from 'components/upload-image';
  import api from 'api/user';
  import { Toast } from 'vant';
  export default {
    components: {
      uploadImage
    },
    data() {
      return {
        display: {
          sexSelect: false
        },
        imageUrl: '', //用户头像
        userName: '', //昵称
        sex: '', //昵称
        sexId: '',
        actions: [{name: '男', id:1}, {name: '女', id:2}],

      }
    },
    watch: {
      userInfo(nval) {
        console.log(nval);
        this.getUserInfo()
      }
    },
    computed: {
      ...mapState(['userInfo'])
    },
    created() {

      this.getUserInfo()
    },
    methods: {
      getUserInfo() {
        this.imageUrl = this.userInfo.headimgurl;
        this.userName = this.userInfo.nickname;
        this.sex = this.userInfo.sex === 1?'男':this.userInfo.sex === 2?'女':'';
        this.sexId = this.userInfo.sex;
      },
      goBack() {
        this.$router.go(-1)
      },
      getImage(img) {
        this.imageUrl = img[0].url;
        console.log(this.imageUrl);
        //需要把上传组件的图片列表置空，否则将不能再次上传
        this.$refs['uploadImage'].picList = [];
      },
      //打开性别选择框
      openSexSelect() {
        this.display.sexSelect = true;
      },
      //选择性别
      onSelectSex(item) {
        this.sex = item.name;
        this.sexId = item.id;
        this.display.sexSelect = false;
      },
      //提交个人资料
      submitInfo() {
        if (this.userName === '') {
          Toast('昵称不能为空');
          return
        }
        const params = {
          headimgurl: this.imageUrl,
          sex: this.sexId,
          nickName: this.userName
        }
        api.updateUserInfo(params)
        .then(res=>{
          console.log(res);
          Toast.success('修改成功');
          this.getuserInfo()
          this.$router.push({
            name:'mine'
          })
        })

        console.log(params);
      },
      ...mapActions(['getuserInfo'])
    },
    filters: {
      getSex(val) {
        if (val === 1) {
          return '男'
        }else{
          return '女'
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import 'common/sass/theme.scss';
  .title-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: $top-nav-height;
    line-height: $top-nav-height;
    padding: 0 10px;
    border-bottom: 1px solid #ededed;
    background: #fff;
    .back-icon-box {
      display: inline-block;
      .go-back-icon {
        font-size: 20px;
      }
    }
    .settle-title {
    }
  }
  .info-box{
    padding: 10px;
    .user-image-box{
      margin-bottom: 10px;
      .user-image{
        display: inline-block;
        width: 60px;
        height: 60px;
        margin-right: 10px;
        border-radius: 100%;
        overflow: hidden;
      }
    }

  }
  .change-image-btn{
    font-size: 14px;
    color: #f90;
  }
</style>